module.exports = __webpack_public_path__ + "assets/img/block-left-5ca5367d.png";